export default "__VITE_ASSET__cfbdb1ec__"